import { useParams } from "react-router-dom";
import { useApp } from "@/hooks/use-app-context";
import { MyContributionsPage } from "@/features/my-contributions/MyContributionsPage";

/** Route /:lang/my-contributions. The page itself lives in features/my-contributions. */
const MyContributions = () => {
  const { language } = useApp();
  const { lang } = useParams<{ lang: string }>();
  return <MyContributionsPage lang={lang ?? language} />;
};

export default MyContributions;
